module.exports = __webpack_public_path__ + "img/video_play.fa183141.png";